<script>
import Logo from '@/components/Logo.vue'
import links from '@/helpers/saleLinks'
export default {
  components: {Logo},
  data() {
    return {  
        links: [ {componentName: 'saleHome', title: 'Hem' },
          {componentName: 'saleCost', title: 'Våra produkter', scrollId: 'our_products' },
          {componentName: 'saleExample', title: 'Skapat med JAMII', scrollId: 'created_with_jamii' },]
    }
  }, 
  created()
  {
   
  },
  computed: {
    selectedPage() { return this.$route.name }
  },
  watch:
  {
    
  },
  methods:
  {
    goTopage(link)
    {
      if (link.scrollId) {
        const element = document.getElementById(link.scrollId);
        if (element) {
          window.scrollTo({
            top: element.offsetTop - 100, // Adjust offset as needed for fixed header
            behavior: 'smooth'
          });
        }
      } else {
        $(window).scrollTop(0);   
        this.$router.push({ name: link.componentName })
      }
    },
    openOrderModal() {
      this.$emit('openOrderModal');
    }
  }
}
</script>
<template>
  <section class="Menu"> 
    <div class="float-left Menu-logo">
      <img src="@/assets/imgs/new_logo.png" width=100%>
    </div>
    <div class="float-right" style="margin-right: 7vw">
      <button @click="goTopage({componentName: 'saleCost', scrollId: 'our_products' })">Beställ</button>
    </div>     
    <ul>
      <li v-for="link in links" @click="goTopage(link)" :style="{'color': link.componentName == selectedPage ? '#f25c43' : ''}">
        {{  link.title }}
      </li>      
    </ul>

  </section>
</template>
<style scoped>
.Menu-logo
{
  margin: 22px 0px 0px 7vw; width: 121px;
}
.Menu-logo img
{
  width: 100%;
}

button
{
    border-radius: 31px;
    margin: 20px 7px;
    padding: 12px 30px;
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    text-transform: uppercase;
    font-size: 16pt;
    background-color: #f25c43;
    color: white;
    border-color: #f25c43;
    border: 2px solid #f25c43;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    background-color: #e04a35;
    border-color: #e04a35;
}

button:active {
    transform: translateY(0px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transition: all 0.1s ease;
}
.Menu-order
{

}
.Menu
{
  width:100%; 
  height: 99px; 
  color: rgb(0, 0, 0);
  position: fixed;
  z-index: 20;
  background: rgba(255,255,255,0.9);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
  border-bottom: 1px solid rgba(242, 92, 67, 0.1);
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 16pt;
  transition: all 0.3s ease;
}


ul{
  text-align: center;
  margin: auto;
  padding: 0px;
  display: flex;
  justify-content: left;
  margin-left: 24vw;

}
li{ 
  display: inline-block;
    vertical-align: top;
    padding: 36px 1vw;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 8px;
    position: relative;
}

li:hover {
    color: #f25c43 !important;
    background-color: rgba(242, 92, 67, 0.08);
    transform: translateY(-1px);
}

li:active {
    transform: translateY(0px);
    transition: all 0.1s ease;
}

</style>
